import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { NotificationRenderer } from './utils/notifier';
import App from './app/app';
import './tools/i18n';
import { amplitudeInit } from './tools/amplitude';
import { logBuildBanner } from './utils/buildInfo';
// import '@unified-checkout/design-system/styles/styles.scss';
// import './styles.scss';

// Version / build type / build date are inlined at build time from the build
// environment (Amplify Environment Variables) — see ./utils/buildInfo.ts.
logBuildBanner();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false
    },
  },
});

// Initialize Amplitude
amplitudeInit();

root.render(
  // <StrictMode>
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <App />
      <NotificationRenderer />
    </QueryClientProvider>
  </BrowserRouter>
  // </StrictMode>
);